import React from 'react';
import PropTypes from 'prop-types';
import request from '../../utils/agent';
import Loader from 'components/Loader';
import { Formik, Field, FieldArray, Form } from 'formik';
import * as Yup from 'yup';
import './AdminCreateEmploee.scss';



export default class AdminCreateEmployess extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            role: 'installer',
            isError: false,
            isSubmited: false,
            companies: [],
            compLoaded: false,
        };

    }

    componentDidMount(){
        this.getCompanyData();
    }

    componentDidUpdate() {
        if(this.state.isSubmited === true) {
            this.getCompanyData();
            this.setState({isSubmited: false});
        }
    }


    getCompanyData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/companies')
                .then(resp => {
                    this.setState({
                        companies: resp.body.companies,
                        compLoaded: true
                    });
                    resolve(resp.body);
                });

        });
    };

    render(){

       // console.log('comp', this.state.companies);

        const refferalOpts = [
            {id: "customer", display: "Customer"},
            {id: "distributor", display: "Distributer"},
            {id: "email", display: "Email"},
            {id: "facebook", display: "Facebook"},
            {id: "instagram", display: "Instagram"},
            {id: "lighting_showroom", display: "Lighting Showroom"},
            {id: "print_ad", display: "Print Ad"},
            {id: "sales_rep", display: "Sales Rep"},
            {id: "tradeshow", display: "Tradeshow"},
            {id: "tv", display: "TV"},
            {id: "word_of_mouth", display: "Word of Mouth"},
        ];

        let companiesArr = [];
        if (this.state.compLoaded === true) {
            companiesArr = this.state.companies.map(company => {
                const option = {};
                option["id"] = company.id;
                option["display"] = company.name;
                return option;
            });
        }

        const companiesOpts = companiesArr.filter(company => company.display != "" && company.display != 0);
        companiesOpts.unshift({id: "", display: "Dealer*"});


        //console.log('companiesOpts', companiesOpts);
        //console.log('compLoaded', this.state.compLoaded);


        const ProfileSchema = Yup.object().shape({
            email: Yup.string().required('This value is required.').email('This value should be a valid email.'),
            first_name: Yup.string().required('This value is required.'),
            last_name: Yup.string().required('This value is required.'),
            phone: Yup.string().required('This value is required.'),
            company_id: Yup.string().required('This value is required.'),
        });

        return(
            <section >
                <div className='admin-profile-container'>
                    <div className='short-desc-hold'>
                        <h3>Add New Employee</h3>
                    </div>
                    {this.state.isSubmited === false ?
                        <div className='details-hold'>
                            <h3>Primary Contact Information</h3>
                            {this.state.compLoaded === true ?
                                <Formik
                                    initialValues={{
                                        email: "",
                                        first_name: "",
                                        last_name: "",
                                        phone: "",
                                        additional_information_hearAboutNoon: "",
                                        company_id: "",

                                    }}
                                    enableReinitialize={false}
                                    validationSchema={ProfileSchema}
                                    onSubmit={(values, actions) => {

                                        let hearedAbout = "";
                                        if (values.additional_information_hearAboutNoon != "" && values.additional_information_hearAboutNoon != []) {
                                            hearedAbout = values.additional_information_hearAboutNoon.join(",")
                                        }

                                        return new Promise((resolve, reject) => {
                                            request.post('/api/createuser')
                                                .send({
                                                    role: this.state.role,
                                                    email: values.email,
                                                    username: values.email,
                                                    first_name: values.first_name,
                                                    last_name: values.last_name,
                                                    additional_information_hearAboutNoon: hearedAbout,
                                                    phone: values.phone,
                                                    company_id: values.company_id,
                                                })
                                                .then(data => {
                                                   // console.log('finished user call');
                                                   // console.log(data);
                                                    this.setState({
                                                        isSubmited: true,
                                                        compLoaded: false,

                                                    });

                                                })
                                                .catch(err => {
                                                    console.error(err);
                                                    this.setState({isError: true});
                                                });
                                        });
                                    }}>
                                    {({
                                          values,
                                          errors,
                                          touched,
                                          handleChange,
                                          handleBlur,
                                          handleSubmit,
                                          isSubmitting,
                                          setFieldValue,
                                          handleReset,
                                          resetForm,
                                          dirty,

                                      }) => (
                                        <Form className='my-f-form' onSubmit={handleSubmit}>
                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='email'
                                                className={errors.email && touched.email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.email}/>
                                            {errors.email && touched.email ?
                                                (<div className='f-field-errors'>{errors.email} </div>) : null
                                            }

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>First Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='first_name'
                                                            component='input'
                                                            className={errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='First Name*'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.first_name}
                                                        />
                                                        {errors.first_name && touched.first_name ? (
                                                            <div
                                                                className='f-field-errors'>{errors.first_name}</div>) : null
                                                        }
                                                    </div>
                                                </div>

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Last Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='last_name'
                                                            component='input'
                                                            className={errors.last_name && touched.last_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='Last Name*'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.last_name}
                                                        />
                                                        {errors.last_name && touched.last_name ?
                                                            (<div
                                                                className='f-field-errors'>{errors.last_name}</div>) : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Primary Phone*</label>
                                            <Field
                                                name='phone'
                                                component='input'
                                                className={errors.phone && touched.phone ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='(___)___-____'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.phone}
                                            />
                                            {errors.phone && touched.phone ?
                                                (<div className='f-field-errors'>{errors.phone}</div>) : null
                                            }

                                            <label className='form-f-label'>How you heard about NOON?</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='additional_information_hearAboutNoon'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {refferalOpts.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            name='additional_information_hearAboutNoon'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.additional_information_hearAboutNoon.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.additional_information_hearAboutNoon.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </div>


                                            <label className='form-f-label'>Select Company*</label>
                                            <Field name='company_id' component='select'
                                                   className='single-choice-selector'>
                                                {companiesOpts.map(option => (
                                                    <option key={`company_id-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </Field>
                                            {errors.company_id && touched.company_id ?
                                                (<div className='f-field-errors'>{errors.company_id}</div>) : null
                                            }

                                            {this.state.isError === true ?
                                                <p className='submission-error-text'>Ooops something went wrong! Please
                                                    try
                                                    again later</p> :
                                                null
                                            }

                                            <button className='form-f-button' type="submit">
                                                Save
                                            </button>


                                        </Form>
                                    )}
                                </Formik> :
                                <Loader/>
                            }
                        </div> :
                        <Loader/>
                    }
                </div>
            </section>
        )
    }

}



// WEBPACK FOOTER //
// ./src/routes/AdminCreateEmployee/index.js